const CCDenturesVsImplants = () => {
	return (
		<>
			<path
				fill="#BADDF4"
				d="M13.01 14.36c-.25-.05-.5-.12-.76-.18-1.33-.32-2.27-.55-3.63-.01-.09.04-.19.04-.28 0-1.37-.55-2.32-.31-3.63.02-.26.07-.51.13-.77.18 2.01.29 5.3.55 9.05 0l.02-.01Z"
			/>
			<path
				fill="#002D55"
				d="M15.57 14.31c0-.18-.15-.33-.33-.35l-.57-.07c-.73-.1-1.48-.25-2.26-.45-1.29-.31-2.41-.58-3.91-.03-1.53-.57-2.65-.29-3.95.04-.74.19-1.49.34-2.22.44l-.56.07c-.18.02-.32.17-.33.35 0 .03.02.05.02.07 0 .12.03.23.12.31l.44.34c.44.37.83.79 1.18 1.25.98 1.23 2.09 2.62 5.3 2.62s4.32-1.39 5.31-2.64c.33-.45.73-.87 1.16-1.23l.45-.35c.1-.08.13-.19.13-.31 0-.02.02-.04.02-.06ZM8.5 18.15c-2.86 0-3.76-1.14-4.71-2.33l-.12-.15c1.46.61 3.42 1.29 4.91 1.29 1.49 0 2.86-.33 4.61-1.12-.95 1.19-1.87 2.31-4.7 2.31h.01Zm-.15-3.99c.09.04.19.04.28 0 1.36-.53 2.3-.31 3.63.01.25.06.5.12.76.18-3.76.56-7.05.29-9.05 0l.77-.18c1.31-.33 2.25-.57 3.63-.02l-.02.01Zm3.51 2.03a.38.38 0 0 1-.38-.38v-.1c-.35.12-.68.2-1 .28v.39a.38.38 0 1 1-.76 0v-.25c-.32.04-.63.07-.95.07v.32a.38.38 0 1 1-.76 0v-.34c-.34-.04-.7-.1-1.07-.19v.15a.38.38 0 1 1-.76 0v-.35c-.25-.07-.5-.15-.75-.24v.15a.38.38 0 1 1-.76 0v-.42c-.06-.02-.12-.05-.18-.07.06 0 .12.02.18.02v-.27a.38.38 0 1 1 .76 0v.35l.75.06v-.11a.38.38 0 1 1 .76 0v.16c.34.02.7.03 1.07.03v-.19a.38.38 0 1 1 .76 0v.18c.31 0 .62-.01.95-.02v-.16a.38.38 0 1 1 .76 0v.12c.33-.02.66-.04 1-.08v-.34a.38.38 0 1 1 .76 0v.26c.25-.03.5-.06.75-.1-.26.12-.51.23-.75.33v.38c0 .21-.17.38-.38.38v-.02Z"
			/>
			<path
				fill="#BADDF4"
				d="M8.58 16.96c-1.48 0-3.45-.68-4.91-1.29l.12.15c.95 1.19 1.85 2.33 4.71 2.33s3.74-1.12 4.7-2.31c-1.75.79-3.15 1.12-4.61 1.12h-.01Z"
			/>
			<path
				fill="#002D55"
				d="M5.46 14.95a.38.38 0 1 0-.76 0v.75a.38.38 0 1 0 .76 0v-.75ZM12.23 15.44v-.49a.38.38 0 1 0-.76 0v.86a.38.38 0 1 0 .76 0v-.38.01ZM6.96 15.25a.38.38 0 1 0-.76 0v.89a.38.38 0 1 0 .76 0v-.89ZM8.78 15.25a.38.38 0 1 0-.76 0v1.27a.38.38 0 1 0 .76 0v-1.27ZM10.48 15.25a.38.38 0 1 0-.76 0v1.13a.38.38 0 1 0 .76 0v-1.13Z"
			/>
			<path fill="#BADDF4" d="m22.7 17.58 5.71-.13-.02-.74-.02-1.07c-.01-.47-3.09-.66-5.72-.55l.05 2.48v.01Z" />
			<path
				fill="#002D55"
				d="M22.7 17.96a.4.4 0 0 1-.26-.1.42.42 0 0 1-.12-.26l-.05-2.48c0-.2.16-.37.36-.38.05 0 5.13-.21 5.94.54.14.13.17.27.17.37l.04 1.8c0 .1-.04.2-.1.27a.42.42 0 0 1-.26.12l-5.71.13-.01-.01Zm.33-2.5.04 1.74 4.96-.11-.03-1.3c-.45-.2-2.44-.4-4.96-.32l-.01-.01Z"
			/>
			<path
				fill="#fff"
				d="m27.15 17.55.2-.26c.17-.22.55-.84.91-.57.04.03.08.2.11.35.03.15.04.31.04.46v.16c0 .2-.19.49-.33.69-.1.14-.27.21-.43.19l-.58-.08.08-.93v-.01Z"
			/>
			<path
				fill="#002D55"
				d="M27.7 18.95h-.11l-.58-.08a.373.373 0 0 1-.32-.4l.08-.93c0-.07.03-.14.08-.2l.26-.34c.19-.25.47-.64.86-.7.18-.02.36.02.51.14.12.09.18.23.25.57.04.17.05.35.05.54v.17c0 .08-.01.35-.41.9-.16.22-.41.35-.68.35l.01-.02Zm-.23-.79.23.03c.28-.32.33-.48.33-.52v-.16c0-.13 0-.26-.03-.37 0-.03-.01-.06-.02-.08-.08.09-.22.28-.27.36l-.21.27-.04.47h.01Z"
			/>
			<path
				fill="#fff"
				d="M24.87 16.61h-.01c-.38-.11-.77.12-.94.49-.1.22-.16.47-.19.74l.02.7c0 .12.08.23.19.26.49.14.97.13 1.46-.03.11-.04.18-.15.18-.27l-.02-.7c-.04-.33-.12-.63-.28-.87a.794.794 0 0 0-.41-.31v-.01Z"
			/>
			<path
				fill="#002D55"
				d="M24.62 19.27c-.26 0-.52-.04-.78-.12a.648.648 0 0 1-.46-.61l-.02-.7c.03-.35.1-.65.22-.91.25-.55.85-.84 1.38-.69.01 0 .03 0 .04.01.23.08.44.24.59.45.19.28.3.62.35 1.04l.02.73c0 .28-.17.54-.43.63-.3.1-.6.16-.9.16l-.01.01Zm-.5-.82c.37.09.72.08 1.08-.03v-.63c-.04-.27-.12-.49-.23-.67a.378.378 0 0 0-.2-.16c-.02 0-.04-.01-.06-.02-.01 0-.02 0-.03-.01-.14-.03-.34.13-.42.31-.08.18-.13.38-.15.61l.02.59-.01.01Z"
			/>
			<path
				fill="#fff"
				d="M25.58 18.61c.47.14.99.08 1.4-.1.21-.09.21-.29.21-.47 0-.23-.03-.47-.09-.69-.07-.25-.19-.46-.41-.61-.33-.23-.86.1-.98.45l-.02.07c-.08.26-.13.52-.12.79v.56h.01Z"
			/>
			<path
				fill="#002D55"
				d="M26.14 19.06c-.22 0-.45-.03-.66-.09a.38.38 0 0 1-.27-.4v-.51c-.02-.31.03-.62.13-.92.13-.39.43-.68.78-.8.29-.1.57-.07.79.08.28.19.47.46.56.82.07.26.1.53.1.79 0 .2 0 .61-.43.81-.31.14-.65.21-.99.21l-.01.01Zm-.19-.76c.3.03.61-.01.87-.13v-.13c0-.2-.02-.4-.08-.59-.05-.19-.13-.31-.26-.39-.02-.01-.07-.01-.13 0-.14.05-.26.17-.28.25-.1.29-.13.52-.12.74v.26-.01Z"
			/>
			<path
				fill="#fff"
				d="M22.73 16.62c.32-.02.63.18.78.48.11.21.18.46.22.73l.02.7c0 .12-.07.23-.18.27-.26.09-.53.13-.79.13"
			/>
			<path
				fill="#002D55"
				d="M22.79 19.31c-.18 0-.38-.17-.38-.38s.17-.37.38-.37c.2 0 .39-.03.58-.09v-.63c-.04-.19-.1-.39-.19-.56a.527.527 0 0 0-.43-.28c-.2.02-.38-.14-.4-.35-.01-.21.14-.39.35-.4.47-.04.92.24 1.14.68.13.25.22.54.26.85l.02.74c0 .29-.17.55-.44.63-.29.1-.59.15-.9.15l.01.01Z"
			/>
			<path
				stroke="#002D55"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={0.75}
				d="m22.64 15.11.09 3.8"
			/>
			<path
				fill="#002D55"
				d="M30.35 10.19a.756.756 0 0 0-.55-.24H21a.73.73 0 0 0-.55.25c-.14.16-.21.37-.19.58l1.01 10.58c.04.39.36.68.75.68h6.97c.39 0 .72-.3.75-.69l.82-10.58a.744.744 0 0 0-.2-.57l-.01-.01Zm-.55.51-.15 1.92h-8.47L21 10.7h8.8Zm-.82 10.58h-6.97l-.76-7.91h8.34l-.61 7.91ZM17.06 24.35a.38.38 0 0 1-.38-.38V8.02a.38.38 0 1 1 .76 0v15.96c0 .21-.17.38-.38.38v-.01Z"
			/>
		</>
	);
};

export default CCDenturesVsImplants;
